import Overlay from 'ol/Overlay';

export default function (map) {
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171510, 6848055],
			element: document.getElementById('bssp-label-dom'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171640, 6848065],
			element: document.getElementById('bssp-label-rathaus'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171545, 6848146],
			element: document.getElementById('bssp-label-burg'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171422, 6848123],
			element: document.getElementById('bssp-label-museum'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171585, 6847957],
			element: document.getElementById('bssp-label-sanitaeter'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171705, 6848180],
			element: document.getElementById('bssp-label-wcno'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171467, 6848140],
			element: document.getElementById('bssp-label-wcnw'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171620, 6848025],
			element: document.getElementById('bssp-label-wcso'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171430, 6847980],
			element: document.getElementById('bssp-label-wcsw'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171503, 6848128],
			element: document.getElementById('bssp-label-loewe'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171583, 6848180],
			element: document.getElementById('bssp-label-burggraben'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171510, 6847925],
			element: document.getElementById('bssp-label-gericht'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171965, 6847875],
			element: document.getElementById('bssp-label-schloss'),
		})
	);
	map.addOverlay(
		new Overlay({
			stopEvent: false,
			position: [1171987, 6848021],
			element: document.getElementById('bssp-label-ritterbrunnen'),
		})
	);
}
